import React from "react";
import { Typography, Box } from "@mui/material";
import ContentContainer from "../../components/common/ContentContainer";

const PositionEntry = ({ position, domain, description }) => {
  return (
    <Box sx={{ mb: 3, p: 2, bgcolor: 'rgba(71, 66, 92, 0.1)', borderRadius: 2 }}>
      <Typography variant="h5" sx={{ mb: 1 }}>{position}</Typography>
      <Typography variant="subtitle1" sx={{ mb: 1, color: '#666' }}>{domain || 'Various Domains'}</Typography>
      <Typography variant="body1">{description || 'We are looking for a talented individual to join our team.'}</Typography>
    </Box>
  );
};

const RolesNeeded = ({ roles }) => {
  // If roles is a simple array of strings, convert it to objects
  const formattedRoles = Array.isArray(roles) 
    ? roles.map(role => {
        if (typeof role === 'string') {
          return { 
            position: role, 
            domain: 'Various Domains', 
            description: 'We are looking for an experienced professional in this field.' 
          };
        }
        return role;
      })
    : [];

  return (
    <ContentContainer
      id="roles-needed"
      sx={{
        p: "0.625em",
        mx: { xs: "1em", md: "4.25em" },
        "& .MuiTypography-h2, .MuiTypography-body1": {
          mb: "0.75em",
        },
      }}
    >
      <Typography variant="h2">Roles Needed</Typography>
      {formattedRoles.length > 0 ? (
        formattedRoles.map((role, index) => (
          <PositionEntry
            key={index}
            position={role.position}
            domain={role.domain}
            description={role.description}
          />
        ))
      ) : (
        <Typography variant="body1">No specific roles available at this time.</Typography>
      )}
    </ContentContainer>
  );
};

export default RolesNeeded;
